import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Table,
  TableHead,
  Grid,
  Box,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useRollbar } from '@rollbar/react';
import { addBreadcrumbAction, popBreadcrumbAction } from '../../../../actions/breadcrumbsAction';
import { addProductsToBundleOptionAction } from '../../../../actions/bundleOptionsAction';
import {
  updateMenuItemOptionAction,
  createMenuItemOptionAction,
} from '../../../../actions/menuItemOptionsAction';
import {
  cancelChoicesAction,
  saveInitialChoicesAction,
} from '../../../../actions/menuItemOptionChoicesAction';
import { formatCurrency } from '../../../../helpers/Helpers';
import { TextButton } from '../Button/TextButton';
import BundleOptionProductCreate from './BundleOptionProductCreate';
import useStyles from './BundleOptionProductAddStyles';
import { dialogContexts } from '../../../../constants/constants';
import ProductEditDialog from '../menuProduct/ProductEditDialog';

/**
 * The dialog for dragging options onto a single menu item
 */
const BundleOptionProductAddDialog = ({
  addProductsToBundleOptionAction,
  openDialog,
  setOpenDialog,
  products,
  bundleOptionId,
  defaultSelectedItems,
  addBreadcrumbAction,
  popBreadcrumbAction,
  bundleOptions,
}) => {
  const rollbar = useRollbar();
  const classes = useStyles();
  const [save, setSave] = useState(false);

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedProductIndex, setSelectedProductIndex] = useState(false);

  const [bundleOptionName, setBundleOptionName] = useState('');
  useEffect(() => {
    setBundleOptionName(
      bundleOptions?.localData?.find((bundleOption) => bundleOption?.objectId === bundleOptionId)
        ?.bundleOptionTitle,
    );
  }, [bundleOptionId]);

  const processedProducts = products?.localData.map((product) => {
    let bundleOptionsForProduct = [];
    bundleOptions?.localData?.forEach((bunldeOption) => {
      if (bunldeOption?.productIds?.includes(product.objectId)) {
        bundleOptionsForProduct = [...bundleOptionsForProduct, bunldeOption?.bundleOptionTitle];
      }
    });

    return {
      ...product,
      bundleOptions: bundleOptionsForProduct,
    };
  });

  let sortedProducts = [];
  bundleOptions?.localData?.forEach((bundleOption) => {
    bundleOption?.productIds?.forEach((productId) => {
      if (
        sortedProducts.filter((sortedProduct) => sortedProduct?.objectId === productId).length === 0
      ) {
        const processedProduct = processedProducts.find(
          (product) => product?.objectId === productId,
        );

        // Error checking
        if (processedProduct === null) {
          rollbar.error(`Error: Product is null ${productId}`);
        }

        sortedProducts = [...sortedProducts, processedProduct];
      }
    });
  });

  processedProducts.forEach((product) => {
    if (
      sortedProducts.filter((sortedProduct) => sortedProduct?.objectId === product?.objectId)
        .length === 0
    ) {
      sortedProducts = [...sortedProducts, product];
    }
  });

  // breadcrumbs
  const [hasBreadcrumb, setHasBreadcrumb] = useState(false); // To ensure we don't pop some other breadcrumb if re-rendered while closed
  useEffect(() => {
    if (openDialog && !hasBreadcrumb) {
      addBreadcrumbAction(`Add menu item`);
      setHasBreadcrumb(true);
    } else if (!openDialog && hasBreadcrumb) {
      popBreadcrumbAction();
      setHasBreadcrumb(false);
    }
  }, [openDialog]);

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const validateForm = () => {
    const formError = false;

    return formError;
  };

  const submit = (event) => {
    event.preventDefault();

    const formError = validateForm();

    if (formError) {
      return;
    }
    addProductsToBundleOptionAction(selectedItems);

    setSave(true);
    closeDialog();
  };

  const tableRef = useRef();
  const [selectedItems, setSelectedItems] = useState([]);

  const selectItem = (itemId, value) => {
    if (value === true && !selectedItems.includes(itemId)) {
      setSelectedItems([...selectedItems, itemId]);
    }

    // Remove item if deselected and in list
    if (value === false) {
      const updatedSelectedItems = selectedItems.filter((item) => item !== itemId);
      setSelectedItems(updatedSelectedItems);
    }
  };

  useEffect(() => {
    setSelectedItems(defaultSelectedItems);
  }, [defaultSelectedItems, openDialog]);

  // Deselect all when closed
  useEffect(() => {
    if (!openDialog) {
      setSelectedItems([]);
    }
  }, [openDialog]);

  const selectAllItems = () => {
    setSelectedItems(products.localData.map((item) => item.id));
  };

  return (
    <Dialog
      open={openDialog}
      onClose={closeDialog}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth
      maxWidth='lg'
      className={classes.dialog}
      onEnter={() => {
        setSave(false);
      }}
      onExited={() => {
        if (!save) {
          // Revert Options back to as they were on enter
          // cancelChoicesAction(menuItemId, optionId);
        }
      }}
    >
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item md={8} xs={12} className={classes.leftColumn}>
            <Box className={classes.modalTitle}>Menu items</Box>
            <Box className={classes.modalDescription}>Select from existing menu items</Box>
            {sortedProducts.length === 0 ? (
              'No menu items to display. Please create some first.'
            ) : (
              <Table tableref={tableRef}>
                <TableHead>
                  <TableRow>
                    <TableCell> </TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Cost</TableCell>
                    <TableCell>Options</TableCell>
                    <TableCell> </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedProducts.map((product, index) => (
                    <TableRow className={classes.row} key={product?.objectId}>
                      <TableCell style={{ width: '20px' }}>
                        <Checkbox
                          style={{
                            color: selectedItems?.includes(product?.objectId)
                              ? '#E54439'
                              : '#BDBDBD',
                          }}
                          checked={selectedItems?.includes(product?.objectId)}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => selectItem(product?.objectId, event.target.checked)}
                        />
                      </TableCell>
                      <TableCell
                        onClick={() =>
                          selectItem(product.objectId, !selectedItems.includes(product.objectId))
                        }
                        style={{ fontSize: '18px' }}
                      >
                        {product?.productTitle}
                      </TableCell>
                      <TableCell
                        onClick={() =>
                          selectItem(product.objectId, !selectedItems.includes(product.objectId))
                        }
                        style={{ fontSize: '16px', whiteSpace: 'nowrap' }}
                      >
                        {product?.price && formatCurrency(product?.price)}
                      </TableCell>
                      <TableCell
                        onClick={() =>
                          selectItem(product.objectId, !selectedItems.includes(product.objectId))
                        }
                      >
                        <Box
                          style={{
                            fontSize: '16px',
                            color: '#2E2E2E',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '300px',
                          }}
                        >
                          {product?.bundleOptions?.join('; ')}
                        </Box>
                      </TableCell>
                      <TableCell
                        style={{
                          backgroundColor: '#FFF',
                          color: '#E54439',
                          width: '65px',
                          padding: 0,
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          setOpenEditDialog(true);
                          setSelectedProductIndex(index);
                        }}
                      >
                        <TextButton style={{ button: { padding: 0 } }}>Edit</TextButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Grid>
          <Grid item md={4} xs={12} className={classes.rightColumn}>
            <Box className={classes.modalDescription}>Create new</Box>
            <BundleOptionProductCreate bundleOptionId={bundleOptionId} />
          </Grid>
        </Grid>

        {selectedProductIndex !== false && (
          <ProductEditDialog
            bundleOptionId={bundleOptionId}
            openDialog={openEditDialog}
            dialogContext={dialogContexts.EDIT}
            setOpenDialog={setOpenEditDialog}
            product={sortedProducts[selectedProductIndex] || {}}
          />
        )}
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid #DCDCDB', minHeight: '50px' }}>
        <Box
          style={{ minHeight: '60px', margin: '0 20px', width: '100%' }}
          display='flex'
          justifyContent='space-between'
        >
          <Box>
            <Box
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                margin: '20px 0',
              }}
            >
              Add {selectedItems?.length} menu item
              {selectedItems?.length === 1 ? '' : 's'}{' '}
              {bundleOptionName ? `to ${bundleOptionName}` : ''}
            </Box>
          </Box>
          <Box display='flex'>
            <Button onClick={closeDialog} color='default'>
              Cancel
            </Button>
            <Button onClick={submit} color='primary' type='submit' form='add-menu-item-option-form'>
              Add menu items
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  products: state.products,
  bundleOptions: state.bundleOptions,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      cancelChoicesAction,
      createMenuItemOptionAction,
      saveInitialChoicesAction,
      updateMenuItemOptionAction,
      addProductsToBundleOptionAction,
      addBreadcrumbAction,
      popBreadcrumbAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(BundleOptionProductAddDialog);
